module.exports = __webpack_public_path__ + "static/media/YM04_4.08c9750c.jpg";